import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";


class FlickrFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hashtag: "",
            handle: "",
            error: false,
            handleError: false,
            loading: false,
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError:false });

    onSubmit = () => {
        const { updateStep, selectedFilterId } = this.props;
        const { hashtag,handle } = this.state;

        if (selectedFilterId == 2 && hashtag == '') {
           this.setState({ error: true });
        } else if (selectedFilterId == 1 && handle == '') {
           this.setState({ handleError: true });
        } else {
            this.setState({ error: false, handleError:false, loading: true });

            var obj = {
                networkId: 6,
                moderation: 0,
                connetedAccount: 0,
                feedType: selectedFilterId,
                account: 0,
                filter: selectedFilterId,
              }
        
              if (selectedFilterId == 1) obj['field1'] = handle.split('@').join('')
              if (selectedFilterId == 2) {
                obj['field2'] = hashtag.split('#').join('')
              } 

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    render() {
        const { hashtag, handle, error, handleError, loading } = this.state;
        const { selectedFilterId } = this.props;
        
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 2 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-hashtag`}></i>
                        </span>
                        <InputField name={"hashtag"} placeholder="Enter hashtag here.." className="form-control p-3" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div> :
                    <div className="selectSource-right mb-3">
                        <div className="position-relative d-flex custom-input">
                            <span className="hastag d-flex align-items-center">
                               <i className={`fas fa-at`}></i>
                            </span>
                            <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                    </div>}
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 2 ? !hashtag.trim() : !handle.trim()} />
                </div> 
            </div>
        )
    }
}

export default FlickrFeed;